'use strict';

/* 
  Rewards Cashback View
    this.paths.rewards.cashback ('/member/dashboard/rewards/cashback')

  Contentful 
    EntityID: 2SgIirplZIVvGd5uesD2tY
    SpaceID: 5s3ysw7vjfxb
    Snapshot: app/content/snapshots/master/entry-2SgIirplZIVvGd5uesD2tY.json (was a Contentful entry, LOAN-490)
*/

function RewardsCashbackView() {
  this.id = null;
  this.node = null;
  this.extends = [_RewardsController, _Paths];

  // Eventhandler Configs
  this.dragging = false;

  this._$classes = {
    animation: '.js--animation-container',
    animationContainer: '.js--ui-generic-layout',
    animationText: '.js--animation-text',
    nextBtn: '.js--next-btn',
    loadingSpinner: '.js--loading-spinner'
  };

  this._animationLoaded = $.Deferred();
  var MEMBER_CONTENTS_KEY = 'bitcoin-cashback-monthly-earned';

  this.init = function () {
    this._super();
    this._$node = $(this.node);
    this.viewedOnceCheck();
  };

  /* When required models are ready initPage() called 
    See: _RewardsController init() function - calls initPage() when models ready 
   */
  this.initPage = function () {
    this._setComputedVariables();
  };

  /*
    viewedOnceCheck: pattern used in interstitial to check if content has been
    viewed at least once.
  */
  this.viewedOnceCheck = function () {
    /*
      If already viewed, send them back to
      rewards view aka rewards-benefit-gallery - 
      this.paths.rewards.side_tray - '/member/dashboard/rewards'
    */
    if (this.productSettings.hasViewedContent(MEMBER_CONTENTS_KEY)) {
      this.history.replaceUrl(Product.shortcutMappings['rewards-benefit-gallery']);
    } else {
      // If have not already viewed, continue to init page when animation is loaded.
      this._onAnimationLoaded();
      this._createGenericLayout();
    }
  };

  this._onAnimationLoaded = function () {
    var _this = this;

    $.when(this._animationLoaded).done(function () {
      _this._$animation = _this._$node.find(_this._$classes.animation)[0];
      _this._$animationText = _this._$node.find(_this._$classes.animationText);
      _this._$nextBtn = _this._$node.find(_this._$classes.nextBtn);
      _this._$loadingSpinner = _this._$node.find(_this._$classes.loadingSpinner);

      _this._$nextBtn.addClass('hide');
      _this._$loadingSpinner.hide();
      _this._$genericLayout.removeClass('hide');

      _this._setupEventListeners();
      _this._setupAnalytics();
    });
  };

  /*
      _createGenericLayout: Programatically create genericLayout with field configs
      to avoid putting it all on the pug.
       media1: lottie animation obj needs to be returned to callback before API can be used
    */
  this._createGenericLayout = function () {
    var _this2 = this;

    this._$genericLayout = this._$node.find(this._$classes.animationContainer)[0];

    this.genericLayoutConfig = {
      contentId: '2SgIirplZIVvGd5uesD2tY',
      contentSpace: 'App',
      contentType: 'genericLayout',
      fieldConfigs: {
        media1: { callback: function callback() {
            return _this2._initAnimation();
          } },
        cta2: { callback: function callback() {} // callback placeholder to override targetID
        } }
    };

    this._$genericLayout.mogo().create('GenericLayout', this.genericLayoutConfig);
  };

  /*
      _initAnimation: at this point, bodymovin api can be used.
      resolve animation loaded obj and set animation interactions
    */
  this._initAnimation = function () {
    this._animationLoaded.resolve();
    this.animationApi = this._$genericLayout.mogo().contentfulFieldItems.media1.animation;

    // Play animation
    this.playAnimation();
  };

  this._setComputedVariables = function () {
    this.presenter.addComputedVariable('cashback_rewards', ['rewards.cashback.since_last_seen.cad'], function (val) {
      var amt = Formatters.formatMoney(val);
      return ' ' + amt + ' ';
    });

    this.presenter.addComputedVariable('crypto_rewards', ['rewards.cashback.since_last_seen.sat'], function (val) {
      var satFormatConfig = { optionalDecimals: true, noCurrencySymbol: true };
      var amt = Formatters.formatMoney(val, satFormatConfig);
      return ' ' + amt + ' sats ';
    });
  };

  this._setupAnalytics = function () {
    this.analytics.pushEvent('virtual-page-view');
    this._$genericLayout.mogo().pushContentfulAnalyticsEvent();
    this._$genericLayout.mogo().contentfulFieldItems.cta2._addDaiToCta(this._$nextBtn[0]);
  };

  this._setupEventListeners = function () {
    // Actions
    this._$nextBtn.on('click', this.markAsViewed.bind(this));
  };

  /*
      markAsViewed: copied wholesale from Interstitial class
    */
  this.markAsViewed = function () {
    this.productSettings.createViewedContent(MEMBER_CONTENTS_KEY, this.goToThePage.bind(this));
  };

  /*
      goToThePage: button is a Product instance, leverages methods to route to target destination
    */
  this.goToThePage = function () {
    var button = this._$genericLayout.mogo().contentfulFieldItems.cta2; // Generic Layout lists the fields in the item
    var targetId = button.getTargetId(button.contentObject.configuration, 'nav-action-1');
    button.gotoTarget(targetId);
  };

  /*
      playAnimation: lottie is a full length animation
      method plays the the animation 
      and displays text near the end of the animation
    */
  this.playAnimation = function (e) {
    this.animationApi.playSegments([80, 300], true); // Don't play from very beginning because don't need to show the arrows for swiping interaction since that interaction is removed as of 20210622
    this.animationApi.loop = false; // set loop to false for ending

    this.animationApi.addEventListener('enterFrame', this._displayContents.bind(this));

    this.analytics.forcePushEvent('generic-event', {
      category: ['Rewards'],
      action: ['Cashback Navigation'],
      label: ['Display earned satoshis']
    });
  };

  this._displayContents = function () {
    // total frames is 300 - 80 (segments ) = 220
    if (this.animationApi.currentFrame >= 170) {
      this._$animationText.removeClass('hide');
      this._$nextBtn.removeClass('hide');
    }
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('crypto_rewards');
    this.presenter.removeComputedVariable('cashback_rewards');
  };
}